
export default {
    companyPortalUrl:'http://localhost:8080',
    //companyPortalUrl:'https://company.zorbis.com',
    companyPortalOrigin:'localhost:8080',
};